@if (report()) {
	<div>
		<div class="columns">
			<div class="report-column">
				<div class="lessons">
					@for (lesson of report()!.lessons; track lesson; let i = $index) {
						<div class="lesson">
							<div class="lesson-and-takes">
								<div class="lesson-blocks">
									<div class="title">{{ lesson.lesson.lesson_text[0].name }}</div>
									<div class="activities-wrapper">
										@for (
											activityAndContents of lesson.activities;
											track activityAndContents;
											let i = $index
										) {
											<div
												class="activity"
												(click)="
													toggleSelectedActivityReport(
														activityAndContents.activity,
														lesson.lesson.uuid,
														activityAndContents.activity.uuid
													)
												"
											>
												<div
													class="contents-box"
													[class.selected]="
														activityAndContents.activity.uuid ===
														selectedActivityReport()?.activityUuid
													"
													[nz-tooltip]="activityAndContents.activity.activity_text[0].name"
												>
													<span class="activity-number">A{{ i + 1 }}</span>
													<div class="contents-wrapper">
														@for (
															contentAndReport of activityAndContents.contents;
															track contentAndReport
														) {
															<div class="content">
																@switch (contentAndReport.report?.status) {
																	@case (TakeStatus.COMPLETED) {
																		@switch (
																			contentAndReport.content.scoring_method
																		) {
																			@case (ContentScoringMethod.PASS_FAIL) {
																				<img
																					src="/assets/img/completed_person.svg"
																				/>
																				<div class="footer-title">1/1</div>
																			}
																			@case (ContentScoringMethod.VIEWED) {
																				<img
																					src="/assets/img/completed_check.svg"
																				/>
																				<div class="footer-title">1/1</div>
																			}
																			@case (ContentScoringMethod.PERCENTAGE) {
																				<img
																					src="/assets/img/completed_star.svg"
																				/>
																				<div class="footer-title">
																					{{
																						contentAndReport.report
																							?.questions_correct
																					}}
																					/
																					{{
																						contentAndReport.report
																							?.questions_total
																					}}
																				</div>
																			}
																		}
																	}
																	@case (TakeStatus.IN_PROGRESS) {
																		<img src="/assets/img/started.svg" />
																		<div class="footer-title">-</div>
																	}
																	@default {
																		@switch (
																			contentAndReport.content.scoring_method
																		) {
																			@case (ContentScoringMethod.PASS_FAIL) {
																				<img
																					src="/assets/img/not_started_person.svg"
																				/>
																			}
																			@case (ContentScoringMethod.VIEWED) {
																				<img
																					src="/assets/img/not_started_circle.svg"
																				/>
																			}
																			@case (ContentScoringMethod.PERCENTAGE) {
																				<img
																					src="/assets/img/not_started_star.svg"
																				/>
																			}
																		}
																		<div class="footer-title">-</div>
																	}
																}
															</div>
														}
													</div>
												</div>
											</div>
										}
										<div class="activities-summary">
											<div class="activities-summary-completed">
												Completed: {{ lesson.totalContentsCompleted }}/{{
													lesson.totalContentsPossible
												}}
											</div>
											<div class="activities-summary-accuracy">Accuracy: {{ lesson.score }}%</div>
										</div>
									</div>
								</div>
								@if (selectedActivityReport() && lesson.lesson.uuid === selectedLessonUuid()) {
									<div class="takes">
										@if (selectedActivity()) {
											<div class="activity-report-title">
												{{ selectedActivity()!.activity_text[0].name }}
											</div>
										}
										<nz-collapse nzAccordion>
											@for (
												contentReport of selectedActivityReport()!.report;
												track contentReport
											) {
												<div class="content-report-title">
													{{ contentReport.content.content_text[0].name }}
												</div>
												@for (take of contentReport.takes; track take) {
													<nz-collapse-panel
														[nzHeader]="
															'Attempt ' + take.take + '/' + contentReport.takes.length
														"
														(nzActiveChange)="onExpandedTakeChange($event, take)"
													>
														<div>Status: {{ take.status }}</div>
														<div>Scoring Method: {{ take.scoring_method }}</div>

														@if (selectedTakeNumber() && takeReport() && studentUuid()) {
															<app-coach-chat
																[takeNumber]="selectedTakeNumber()!"
																[contentText]="takeReport()!.content.content_text[0]"
																[studentUuid]="studentUuid()!"
															></app-coach-chat>
														}
													</nz-collapse-panel>
												}
											}
										</nz-collapse>
									</div>
								}
							</div>
						</div>
					}
				</div>
			</div>
		</div>
	</div>
}
